module.exports = __webpack_public_path__ + "static/media/loader.405cfed3.gif";